import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Breadcrumbs } from '../../../../library';
import { createMethodology }  from '../../../../../actions';


const Me = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const sending = useSelector( state => state.admin.evaluation.methodology.create_req );

    const [ title, changeTitle ] = useState('');

    const sendData = (e) => {
        e.preventDefault();
        dispatch( createMethodology({ title }, history) );
    }
    
    return(
        <div className="innerWrap">

            <Breadcrumbs items={[
                {name:'Адмiнiстративна панель', link: '/admin'},
                {name:'Методика експертного оцінювання', link: '/admin/evaluation/methodology'},
                {name:'Нова методика експертного оцінювання', link: '/admin/evaluation/methodology/new' }
            ]}/>

            <h1> Нова методика експертного оцінювання </h1>

            <form className="form-container" onSubmit={sendData}>
                <label className="form-label">
                    <div className="form-label-text">
                        <span>Назва</span>
                    </div>
                    <div className="form-label-input">
                        <input
                            type="text"
                            className="form-input"
                            name="title"
                            onChange={(e)=>{
                                changeTitle( e.target.value )
                            }}
                            value={title}
                            placeholder=""
                        />
                    </div>
                </label>
                <div className="form-label">
                    <div className="form-label-text"></div>
                    <div className="form-label-input">
                        <button
                            className={ sending ? "form-button unactive" : "form-button" }
                            type="submit"
                        >
                            {
                                sending ? 'Створюється' : 'Створити!'
                            }

                            {
                                sending &&
                                (
                                <svg className="spinner" viewBox="0 0 50 50">
                                    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                </svg>
                                )
                            }
                        </button>
                    </div>
                </div>
            </form>

        </div>
    )

}


export default Me;